import { render, staticRenderFns } from "./WorkflowQuickPeekModal.vue?vue&type=template&id=63b2bba2&scoped=true"
import script from "./WorkflowQuickPeekModal.vue?vue&type=script&lang=js"
export * from "./WorkflowQuickPeekModal.vue?vue&type=script&lang=js"
import style0 from "./WorkflowQuickPeekModal.vue?vue&type=style&index=0&id=63b2bba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b2bba2",
  null
  
)

export default component.exports